import { IHttpClient } from '@/core/services/http'
import { SlidersResponse } from '../types/api-responses/sliders'
import { PAGES } from '../types/enums/pages.enum'
import { SECTIONS } from '../types/enums/sections.enum'
import { SlidersModel } from '../types/models/slider.model'

export function createGetSlidersUseCase({
  httpClient,
}: {
  httpClient: IHttpClient
}) {
  return async function () {
    try {
      const response = await httpClient
        .version('v1')
        .get<{ data: SlidersResponse }>('/website/customer/sliders', {
          headers: { 'Content-Type': 'application/json' },
        })

      const data = response.data.data

      return resolver(data)
    } catch (_) {
      return null
    }
  }
}
function resolver(slidersResponse: SlidersResponse | undefined): SlidersModel {
  if (!slidersResponse) return {}

  const result: SlidersModel = {}

  for (const page in slidersResponse) {
    if (Object.prototype.hasOwnProperty.call(slidersResponse, page)) {
      const pageData = slidersResponse[page as PAGES]
      if (!pageData) continue

      result[page as PAGES] = {}

      for (const section in pageData) {
        if (Object.prototype.hasOwnProperty.call(pageData, section)) {
          const sectionItems = pageData[section as SECTIONS]
          if (!sectionItems) continue

          result[page as PAGES]![section as SECTIONS] = sectionItems.map(
            item => {
              const { images, ...rest } = item
              const image = images?.[0] || {}
              return {
                ...rest,
                image: {
                  id: image.id,
                  url: image.original_url,
                  preview: image.preview_url,
                },
              }
            },
          )
        }
      }
    }
  }

  return result
}
